var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{class:['message-tip', { hidden: _vm.hidden }],style:({ '--transition': `${_vm.transition}s` })},[_c('div',{staticClass:"message-content"},[(_vm.type === 'success')?_c('i',{staticClass:"iconfont"},[_vm._v("")]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }